import React, { useEffect, useState } from 'react'
import logo from '../../assets/images/avatars/logo3.png'
import { CAvatar } from '@coreui/react'

const readLoaderTheme = () => document.documentElement.getAttribute('data-theme') || document.body.getAttribute('data-theme') || localStorage.getItem('provio_theme') || 'dark'

const Loader = ({ height = '100vh', background }) => {
  const [theme, setTheme] = useState(readLoaderTheme)
  const resolvedBackground =
    background ||
    (theme === 'light'
      ? '#ffffff'
      : 'var(--ui-dashboard-bg, #111111)')

  useEffect(() => {
    const syncTheme = (event) => {
      setTheme(event?.detail?.theme || readLoaderTheme())
    }

    window.addEventListener('provio-theme-change', syncTheme)
    window.addEventListener('storage', syncTheme)

    return () => {
      window.removeEventListener('provio-theme-change', syncTheme)
      window.removeEventListener('storage', syncTheme)
    }
  }, [])

    return (
        <div className='loader-container' data-theme={theme} style={{ height, background: resolvedBackground }}>
           
                                           <div className="d-flex align-items-center justify-content-center gap-0 ">
                                               <div className="" >
                                                   <CAvatar
                                                       src={logo}
                                                       className="rounded-0"
                                                     style={{ width: '120px', height: '120px' }}
                                                   />
                                               </div>
                                               <span
                                                   style={{
                                                       color: '#4FC3F7',
                                                       fontSize: '18px',
                                                       padding: '0 0',
                                                       marginLeft: '-10px'
                                                   }}
                                               >
                                                   Provio Solutions
                                               </span>
                                           </div>
            <div id="container-ball">
            <div id="ball-1" className="circle-ball"></div>
            <div id="ball-2" className="circle-ball"></div>
            <div id="ball-3" className="circle-ball"></div>
            <div id="ball-4" className="circle-ball"></div>
            <div id="ball-5" className="circle-ball"></div>
        </div>
        </div>
    )
}

export default Loader
